<template>
  <!-- ******************* -->
  <!-- *      Modal      * -->
  <!-- ******************* -->
  <!-- This modal is for editing checks -->
  <div
    class="modal fade"
    id="editChecksDialog"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <form id="editChecksForm">
          <div class="modal-header">
            <!-- Close button in the upper right corner -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>

            <!-- Modal Title -->
            <h4 class="modal-title">
              <b>{{ lang.CM1000 }}</b>
            </h4>
          </div>
          <div class="modal-body">
            <!-- Accordion - hides content that is not used -->
            <div
              class="panel-group"
              id="accordionEditChecks"
              role="tablist"
              aria-multiselectable="true"
            >
              <div class="panel panel-default">
                <!-- Accordion entry 1 -->
                <div
                  class="panel-heading"
                  role="button"
                  id="headingEditChecksGeneral"
                  data-toggle="collapse"
                  data-parent="#accordionEditChecks"
                  href="#collapseEditChecksGeneral"
                  aria-expanded="true"
                  aria-controls="collapseEditChecksGeneral"
                >
                  <h4 class="panel-title">
                    <!-- General Settings -->
                    <a class="collapsed">{{ lang.CM1001 }}</a>
                  </h4>
                </div>
                <div
                  id="collapseEditChecksGeneral"
                  class="panel-collapse collapse in"
                  role="tabpanel"
                  aria-labelledby="headingEditChecksGeneral"
                >
                  <div class="panel-body" v-if="!loading">
                    <!-- Checkboxes Collum -->
                    <div class="col-md-4">
                      <a
                        role="button"
                        class="btn btn-default btn-cb-edit-checks"
                        @click="
                          generalSettingsData.IsReadonly ||
                            toggleSetting('SurveyInstanceVisibleInNotification')
                        "
                        :disabled="generalSettingsData.IsReadonly"
                      >
                        <i
                          class="material-icons md-24 text-primary"
                          v-if="
                            generalSettingsData.SurveyInstanceVisibleInNotification >
                            0
                          "
                          >check_box</i
                        >
                        <i
                          class="material-icons md-24 text-primary"
                          v-else-if="
                            generalSettingsData.SurveyInstanceVisibleInNotification <
                            0
                          "
                          >indeterminate_check_box</i
                        >
                        <i class="material-icons md-24" v-else
                          >check_box_outline_blank</i
                        >
                        <span>{{ lang.CM1002 }}</span>
                      </a>
                      <a
                        role="button"
                        class="btn btn-default btn-cb-edit-checks"
                        @click="
                          generalSettingsData.IsReadonly ||
                            toggleSetting('SurveyInstanceExternalInterface')
                        "
                        :disabled="generalSettingsData.IsReadonly"
                      >
                        <i
                          class="material-icons md-24 text-primary"
                          v-if="
                            generalSettingsData.SurveyInstanceExternalInterface >
                            0
                          "
                          >check_box</i
                        >
                        <i
                          class="material-icons md-24 text-primary"
                          v-else-if="
                            generalSettingsData.SurveyInstanceExternalInterface <
                            0
                          "
                          >indeterminate_check_box</i
                        >
                        <i class="material-icons md-24" v-else
                          >check_box_outline_blank</i
                        >
                        <span>{{ lang.CM1003 }}</span>
                      </a>
                      <a
                        role="button"
                        class="btn btn-default btn-cb-edit-checks"
                        @click="
                          generalSettingsData.IsReadonly ||
                            toggleSetting('SurveyInstanceLocationNotification')
                        "
                        :disabled="generalSettingsData.IsReadonly"
                      >
                        <i
                          class="material-icons md-24 text-primary"
                          v-if="
                            generalSettingsData.SurveyInstanceLocationNotification >
                            0
                          "
                          >check_box</i
                        >
                        <i
                          class="material-icons md-24 text-primary"
                          v-else-if="
                            generalSettingsData.SurveyInstanceLocationNotification <
                            0
                          "
                          >indeterminate_check_box</i
                        >
                        <i class="material-icons md-24" v-else
                          >check_box_outline_blank</i
                        >
                        <span>{{ lang.CM1004 }}</span>
                      </a>
                      <a
                        role="button"
                        class="btn btn-default btn-cb-edit-checks"
                        @click="
                          generalSettingsData.IsReadonly ||
                            toggleSetting('SurveyInstanceQueryTool')
                        "
                        :disabled="generalSettingsData.IsReadonly"
                      >
                        <i
                          class="material-icons md-24 text-primary"
                          v-if="generalSettingsData.SurveyInstanceQueryTool > 0"
                          >check_box</i
                        >
                        <i
                          class="material-icons md-24 text-primary"
                          v-else-if="
                            generalSettingsData.SurveyInstanceQueryTool < 0
                          "
                          >indeterminate_check_box</i
                        >
                        <i class="material-icons md-24" v-else
                          >check_box_outline_blank</i
                        >
                        <span>{{ lang.CM1005 }}</span>
                      </a>
                      <a
                        role="button"
                        class="btn btn-default btn-cb-edit-checks"
                        @click="
                          generalSettingsData.IsReadonly ||
                            toggleSetting('SurveyInstanceDashboard')
                        "
                        :disabled="generalSettingsData.IsReadonly"
                      >
                        <i
                          class="material-icons md-24 text-primary"
                          v-if="generalSettingsData.SurveyInstanceDashboard > 0"
                          >check_box</i
                        >
                        <i
                          class="material-icons md-24 text-primary"
                          v-else-if="
                            generalSettingsData.SurveyInstanceDashboard < 0
                          "
                          >indeterminate_check_box</i
                        >
                        <i class="material-icons md-24" v-else
                          >check_box_outline_blank</i
                        >
                        <span>{{ lang.CM1006 }}</span>
                      </a>
                      <a
                        role="button"
                        class="btn btn-default btn-cb-edit-checks"
                        @click="
                          generalSettingsData.IsReadonly ||
                            toggleSetting('SurveyInstanceCheckExplorer')
                        "
                        :disabled="generalSettingsData.IsReadonly"
                      >
                        <i
                          class="material-icons md-24 text-primary"
                          v-if="
                            generalSettingsData.SurveyInstanceCheckExplorer > 0
                          "
                          >check_box</i
                        >
                        <i
                          class="material-icons md-24 text-primary"
                          v-else-if="
                            generalSettingsData.SurveyInstanceCheckExplorer < 0
                          "
                          >indeterminate_check_box</i
                        >
                        <i class="material-icons md-24" v-else
                          >check_box_outline_blank</i
                        >
                        <span>{{ lang.CM1007 }}</span>
                      </a>
                      <a
                        role="button"
                        class="btn btn-default btn-cb-edit-checks"
                        @click="
                          generalSettingsData.IsReadonly ||
                            toggleSetting('SurveyInstanceAggregatedReport')
                        "
                        :disabled="generalSettingsData.IsReadonly"
                      >
                        <i
                          class="material-icons md-24 text-primary"
                          v-if="
                            generalSettingsData.SurveyInstanceAggregatedReport >
                            0
                          "
                          >check_box</i
                        >
                        <i
                          class="material-icons md-24 text-primary"
                          v-else-if="
                            generalSettingsData.SurveyInstanceAggregatedReport <
                            0
                          "
                          >indeterminate_check_box</i
                        >
                        <i class="material-icons md-24" v-else
                          >check_box_outline_blank</i
                        >
                        <span>{{ lang.CM1008 }}</span>
                      </a>
                      <a
                        role="button"
                        class="btn btn-default btn-cb-edit-checks"
                        @click="
                          generalSettingsData.IsReadonly ||
                            toggleSetting('SurveyInstanceRawDataExports')
                        "
                        :disabled="generalSettingsData.IsReadonly"
                      >
                        <i
                          class="material-icons md-24 text-primary"
                          v-if="
                            generalSettingsData.SurveyInstanceRawDataExports > 0
                          "
                          >check_box</i
                        >
                        <i
                          class="material-icons md-24 text-primary"
                          v-else-if="
                            generalSettingsData.SurveyInstanceRawDataExports < 0
                          "
                          >indeterminate_check_box</i
                        >
                        <i class="material-icons md-24" v-else
                          >check_box_outline_blank</i
                        >
                        <span>{{ lang.CM1009 }}</span>
                      </a>
                      <a
                        role="button"
                        class="btn btn-default btn-cb-edit-checks"
                        @click="
                          generalSettingsData.IsReadonly ||
                            toggleSetting('SurveyInstanceFrequencies')
                        "
                        :disabled="generalSettingsData.IsReadonly"
                      >
                        <i
                          class="material-icons md-24 text-primary"
                          v-if="
                            generalSettingsData.SurveyInstanceFrequencies > 0
                          "
                          >check_box</i
                        >
                        <i
                          class="material-icons md-24 text-primary"
                          v-else-if="
                            generalSettingsData.SurveyInstanceFrequencies < 0
                          "
                          >indeterminate_check_box</i
                        >
                        <i class="material-icons md-24" v-else
                          >check_box_outline_blank</i
                        >
                        <span>{{ lang.CM1010 }}</span>
                      </a>
                      <a
                        role="button"
                        class="btn btn-default btn-cb-edit-checks"
                        @click="
                          generalSettingsData.IsReadonly ||
                            toggleSetting('SurveyInstanceMediaExplorer')
                        "
                        :disabled="generalSettingsData.IsReadonly"
                      >
                        <i
                          class="material-icons md-24 text-primary"
                          v-if="
                            generalSettingsData.SurveyInstanceMediaExplorer > 0
                          "
                          >check_box</i
                        >
                        <i
                          class="material-icons md-24 text-primary"
                          v-else-if="
                            generalSettingsData.SurveyInstanceMediaExplorer < 0
                          "
                          >indeterminate_check_box</i
                        >
                        <i class="material-icons md-24" v-else
                          >check_box_outline_blank</i
                        >
                        <span>{{ lang.CM1011 }}</span>
                      </a>
                      <a
                        role="button"
                        class="btn btn-default btn-cb-edit-checks"
                        @click="
                          generalSettingsData.IsReadonly ||
                            toggleSetting('SurveyInstanceCxReporting')
                        "
                        :disabled="generalSettingsData.IsReadonly"
                      >
                        <i
                          class="material-icons md-24 text-primary"
                          v-if="
                            generalSettingsData.SurveyInstanceCxReporting > 0
                          "
                          >check_box</i
                        >
                        <i
                          class="material-icons md-24 text-primary"
                          v-else-if="
                            generalSettingsData.SurveyInstanceCxReporting < 0
                          "
                          >indeterminate_check_box</i
                        >
                        <i class="material-icons md-24" v-else
                          >check_box_outline_blank</i
                        >
                        <span>{{ lang.CM1077 }}</span>
                      </a>
                    </div>

                    <!-- Input fields collum -->
                    <div class="col-md-8">
                      <div class="form-group fg-general-settings-input">
                        <label
                          for="inputCustomReportingDateCheckMgmtEdit"
                          class="col-md-4 control-label"
                          >{{ lang.CM1013 }}</label
                        >
                        <div class="col-md-7">
                          <input
                            type="date"
                            class="form-control custom-reporting-date-input"
                            id="inputCustomReportingDateCheckMgmtEdit"
                            :disabled="
                              disabled.inputCustomReportingDateCheckMgmtEdit
                            "
                            v-model="
                              generalSettingsData.SurveyInstanceCustomReportingDate
                            "
                          />
                        </div>
                        <div class="col-md-1">
                          <button
                            id="inputCustomReportingDateCheckMgmtEditToggle"
                            class="btn-edit"
                            type="button"
                            v-show="
                              this.generalSettingsData
                                .MaxSurveyInstanceStatusId <= 200
                            "
                            @click="
                              toggleBtn(
                                'inputCustomReportingDateCheckMgmtEdit'
                              );
                              return false;
                            "
                          >
                            <i class="material-icons">edit</i>
                          </button>
                        </div>
                      </div>

                      <div
                        class="form-group fg-general-settings-input"
                        v-if="languageStringsReceived && !feature.isAudiTarget"
                      >
                        <label
                          for="checkManagementEditModalSelectSurveyInstanceType"
                          class="col-md-4 control-label"
                          >{{ lang.CM1036 }}</label
                        >
                        <div class="col-md-7">
                          <select2
                            :key="selectedCheckIds[0]"
                            class="form-control"
                            id="checkManagementEditModalSelectSurveyInstanceType"
                            v-model="generalSettingsData.SurveyInstanceType"
                            :afterChange="surveyInstanceTypeChanged"
                            :disabled="
                              disabled.checkManagementEditModalSelectSurveyInstanceType
                            "
                          >
                            <option value="FO">{{ lang.CM1037 }}</option>
                            <option value="MA">{{ lang.CM1038 }}</option>
                            <option value="AG">{{ lang.CM1039 }}</option>
                            <option value="DCT">{{ lang.CM1074 }}</option>
                            <option value="DCA">{{ lang.CM1075 }}</option>
                          </select2>
                        </div>
                        <div class="col-md-1">
                          <button
                            id="checkManagementEditModalSelectSurveyInstanceTypeToggle"
                            class="btn-edit"
                            type="button"
                            v-show="
                              this.generalSettingsData
                                .MaxSurveyInstanceStatusId <= 200
                            "
                            @click="
                              toggleBtn(
                                'checkManagementEditModalSelectSurveyInstanceType'
                              );
                              return false;
                            "
                          >
                            <i class="material-icons">edit</i>
                          </button>
                        </div>
                      </div>
                      <div
                        class="form-group fg-general-settings-input"
                        v-show="
                          generalSettingsData.SurveyInstanceType === 'FO' ||
                          generalSettingsData.SurveyInstanceType === 'MA'
                        "
                      >
                        <label
                          for="checkManagementEditModalSelectUser"
                          class="col-md-4 control-label"
                          >{{ lang.CM1015 }}</label
                        >
                        <div class="col-md-7">
                          <select2
                            :key="generalSettingsData.SurveyInstanceType"
                            class="form-control"
                            id="checkManagementEditModalSelectUser"
                            name="checkManagementEditModalSelectUser"
                            v-model="
                              generalSettingsData.SurveyInstanceAssignedShopperGuid
                            "
                            :afterChange="SurveyInstanceShopperChanged"
                            :placeholder="' '"
                            :allowClear="true"
                            :disabled="
                              disabled.checkManagementEditModalSelectUser
                            "
                          >
                            {{ generalSettingsData.SurveyInstanceType }}
                            <option
                              v-for="user in dataLists.shopperList"
                              :key="user.Guid"
                              :value="user.Guid"
                            >
                              {{ user.Shopper }}
                            </option>
                          </select2>
                        </div>
                        <div class="col-md-1">
                          <button
                            id="checkManagementEditModalSelectUserToggle"
                            class="btn-edit"
                            type="button"
                            v-show="
                              this.generalSettingsData
                                .MaxSurveyInstanceStatusId <= 200
                            "
                            @click="
                              toggleBtn('checkManagementEditModalSelectUser');
                              return false;
                            "
                          >
                            <i class="material-icons">edit</i>
                          </button>
                        </div>
                      </div>
                      <template
                        v-if="generalSettingsData.SurveyInstanceType === 'AG'"
                      >
                        <template
                          v-if="
                            feature.isAudiTarget &&
                            feature.isEnabled('leadAgencies')
                          "
                        >
                          <div
                            class="form-group fg-general-settings-input"
                            v-show="
                              generalSettingsData.SurveyInstanceType === 'AG'
                            "
                          >
                            <label
                              for="checkManagementEditModalSelectLeadAgency"
                              class="col-md-4 control-label"
                              >{{ lang.CM1066 }}</label
                            >
                            <div class="col-md-7">
                              <select2
                                class="form-control"
                                id="checkManagementEditModalSelectLeadAgency"
                                name="checkManagementEditModalSelectLeadAgency"
                                ref="checkEditSelectLeadAgency"
                                v-model="
                                  generalSettingsData.SurveyInstanceAssignedLeadAgencyGuid
                                "
                                :afterChange="
                                  SurveyInstanceAssignedLeadAgencyGuidChanged
                                "
                                :disabled="
                                  disabled.checkManagementEditModalSelectLeadAgency
                                "
                              >
                                <option
                                  v-for="agency in leadAgencies"
                                  :key="agency.AgencyGuid"
                                  :value="agency.AgencyGuid"
                                >
                                  {{ agency.AgencyName }}
                                </option>
                              </select2>
                            </div>
                            <div class="col-md-1">
                              <button
                                id="checkManagementEditModalSelectLeadAgencyToggle"
                                class="btn-edit"
                                type="button"
                                v-show="
                                  this.generalSettingsData
                                    .MaxSurveyInstanceStatusId <= 200
                                "
                                @click="
                                  toggleBtn(
                                    'checkManagementEditModalSelectLeadAgency'
                                  );
                                  return false;
                                "
                              >
                                <i class="material-icons">edit</i>
                              </button>
                            </div>
                          </div>
                          <div
                            class="form-group fg-general-settings-input"
                            v-if="!globals.currentUserInfo.IsAudiUser"
                          >
                            <label
                              for="checkManagementEditModalSelectLocalAgency"
                              class="col-md-4 control-label"
                              >{{ lang.CM1067 }}</label
                            >
                            <div class="col-md-7">
                              <select2
                                class="form-control"
                                id="checkManagementEditModalSelectLocalAgency"
                                name="checkManagementEditModalSelectLocalAgency"
                                ref="checkEditSelectLocalAgency"
                                v-model="
                                  generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid
                                "
                                :afterChange="
                                  SurveyInstanceAssignedLocalAgencyGuidChanged
                                "
                                :placeholder="' '"
                                :allowClear="true"
                                :disabled="
                                  disabled.checkManagementEditModalSelectLocalAgency
                                "
                              >
                                <option
                                  v-for="agency in localAgencies"
                                  :key="agency.AgencyGuid"
                                  :value="agency.AgencyGuid"
                                >
                                  {{ agency.AgencyName }}
                                </option>
                              </select2>
                            </div>
                            <div class="col-md-1">
                              <button
                                id="checkManagementEditModalSelectLocalAgencyToggle"
                                class="btn-edit"
                                type="button"
                                v-show="
                                  this.generalSettingsData
                                    .MaxSurveyInstanceStatusId <= 200
                                "
                                @click="
                                  toggleBtn(
                                    'checkManagementEditModalSelectLocalAgency'
                                  );
                                  return false;
                                "
                              >
                                <i class="material-icons">edit</i>
                              </button>
                            </div>
                          </div>
                        </template>
                        <div
                          class="form-group fg-general-settings-input"
                          v-else
                        >
                          <label
                            for="checkManagementEditModalSelectAgency"
                            class="col-md-4 control-label"
                            >{{ lang.CM1016 }}</label
                          >
                          <div class="col-md-7">
                            <select2
                              class="form-control"
                              id="checkManagementEditModalSelectAgency"
                              name="checkManagementEditModalSelectAgency"
                              v-model="
                                generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid
                              "
                              :afterChange="
                                SurveyInstanceAssignedLocalAgencyGuidChanged
                              "
                              :placeholder="' '"
                              :allowClear="true"
                              :disabled="
                                disabled.checkManagementEditModalSelectAgency
                              "
                            >
                              <option
                                v-for="agency in dataLists.agencyList"
                                :key="agency.AgencyGuid"
                                :value="agency.AgencyGuid"
                              >
                                {{ agency.AgencyName }}
                              </option>
                            </select2>
                          </div>
                          <div class="col-md-1">
                            <button
                              id="checkManagementEditModalSelectAgencyToggle"
                              class="btn-edit"
                              type="button"
                              v-show="
                                this.generalSettingsData
                                  .MaxSurveyInstanceStatusId <= 200
                              "
                              @click="
                                toggleBtn(
                                  'checkManagementEditModalSelectAgency'
                                );
                                return false;
                              "
                            >
                              <i class="material-icons">edit</i>
                            </button>
                          </div>
                        </div>
                      </template>
                      <div
                        class="form-group fg-general-settings-input"
                        v-if="projectSelected"
                      >
                        <div class="col-md-11">
                          <label
                            for="checkManagementEditModalSelectWave"
                            class="col-md-4 control-label"
                            style="padding-left: 0px"
                            >{{ lang.CM1028 }}</label
                          >
                          <div class="col-md-8" style="padding-right: 0px">
                            <select2
                              class="form-control"
                              id="checkManagementEditModalSelectWave"
                              name="checkManagementEditModalSelectWave"
                              v-model="
                                generalSettingsData.SurveyInstanceWaveGuid
                              "
                              :afterChange="SurveyInstanceWaveGuidChanged"
                              :placeholder="' '"
                              :allowClear="true"
                              :disabled="
                                disabled.checkManagementEditModalSelectWave
                              "
                            >
                              <option
                                v-for="wave in wavesOfProject"
                                :key="wave.WaveGuid"
                                :value="wave.WaveGuid"
                              >
                                {{ wave.WaveName }}
                              </option>
                            </select2>
                          </div>

                          <label
                            for="checkManagementEditModalSelectScenario"
                            class="col-md-4 control-label"
                            style="padding-left: 0px"
                            >{{ lang.CM1014 }}</label
                          >
                          <div class="col-md-8" style="padding-right: 0px">
                            <select2
                              class="form-control"
                              id="checkManagementEditModalSelectScenario"
                              name="checkManagementEditModalSelectScenario"
                              v-model="
                                generalSettingsData.SurveyInstanceScenarioGuid
                              "
                              :disabled="
                                disabled.checkManagementEditModalSelectScenario ||
                                !generalSettingsData.SurveyInstanceWaveGuid
                              "
                              :placeholder="' '"
                              :allowClear="true"
                            >
                              <option
                                v-for="scenario in scenariosOfWave"
                                :key="scenario.ScenarioGuid"
                                :value="scenario.ScenarioGuid"
                              >
                                {{ scenario.ScenarioName }}
                              </option>
                            </select2>
                          </div>
                        </div>
                        <div class="col-md-1">
                          <button
                            id="checkManagementEditModalSelectWaveToggle"
                            style="
                              position: relative;
                              overflow: hidden;
                              margin-top: 25px;
                            "
                            class="btn-edit"
                            type="button"
                            v-show="
                              this.generalSettingsData
                                .MaxSurveyInstanceStatusId <= 200
                            "
                            @click="
                              toggleBtn('checkManagementEditModalSelectWave');
                              toggleBtn(
                                'checkManagementEditModalSelectScenario'
                              );
                              return false;
                            "
                          >
                            <i class="material-icons">edit</i>
                          </button>
                        </div>
                      </div>
                      <div
                        class="form-group fg-general-settings-input"
                        v-if="projectSelected"
                      >
                        <label
                          for="checkManagementEditModalSelectLocation"
                          class="col-md-4 control-label"
                          >{{ lang.CM1029 }}</label
                        >
                        <div class="col-md-7">
                          <select2
                            class="form-control"
                            id="checkManagementEditModalSelectLocation"
                            name="checkManagementEditModalSelectLocation"
                            v-model="
                              generalSettingsData.SurveyInstanceLocationGuid
                            "
                            :afterChange="selectedLocationChanged"
                            :disabled="
                              disabled.checkManagementEditModalSelectLocation
                            "
                          >
                            <option
                              v-for="location in locationsOfSelectedClient"
                              :key="location.LocationGuid"
                              :value="location.LocationGuid"
                            >
                              ({{ location.LocationStoreId }})
                              {{ location.LocationAddress }}
                            </option>
                          </select2>
                        </div>
                        <div class="col-md-1">
                          <button
                            id="checkManagementEditModalSelectLocationToggle"
                            class="btn-edit"
                            type="button"
                            v-show="
                              this.generalSettingsData
                                .MaxSurveyInstanceStatusId <= 190 &&
                              generalSettingsData.SurveyInstanceLocationGuid !=
                                '-1'
                            "
                            @click="
                              toggleBtn(
                                'checkManagementEditModalSelectLocation'
                              );
                              return false;
                            "
                          >
                            <i class="material-icons">edit</i>
                          </button>
                        </div>
                      </div>
                      <div
                        class="form-group fg-general-settings-input"
                        v-if="selectedProject"
                      >
                        <label
                          for="checkManagementEditModalSelectBriefing"
                          class="col-md-4 control-label"
                          >{{ lang.CM1034 }}</label
                        >
                        <div class="col-md-7">
                          <select2
                            class="form-control"
                            id="checkManagementEditModalSelectBriefing"
                            v-model="generalSettingsData.BriefingDownloadGuid"
                            :placeholder="' '"
                            :allowClear="true"
                            :disabled="
                              disabled.checkManagementEditModalSelectBriefing
                            "
                          >
                            <option
                              v-for="briefing in briefingAttachments"
                              :key="briefing.DownloadId"
                              :value="briefing.DownloadId"
                            >
                              {{ briefing.FileName }}
                            </option>
                          </select2>
                        </div>
                        <div class="col-md-1">
                          <button
                            id="checkManagementEditModalSelectBriefingToggle"
                            class="btn-edit"
                            type="button"
                            v-show="
                              this.generalSettingsData
                                .MaxSurveyInstanceStatusId <= 190
                            "
                            @click="
                              toggleBtn(
                                'checkManagementEditModalSelectBriefing'
                              );
                              return false;
                            "
                          >
                            <i class="material-icons">edit</i>
                          </button>
                        </div>
                      </div>
                      <div
                        class="form-group fg-general-settings-input"
                        v-if="selectedProject"
                      >
                        <label
                          for="checkManagementEditModalSelectSurvey"
                          class="col-md-4 control-label"
                          >{{ lang.CM1035 }}</label
                        >
                        <div class="col-md-7">
                          <select2
                            class="form-control"
                            id="checkManagementEditModalSelectSurvey"
                            v-model="generalSettingsData.SurveyDownloadGuid"
                            :placeholder="' '"
                            :allowClear="true"
                            :disabled="
                              disabled.checkManagementEditModalSelectSurvey
                            "
                          >
                            <option
                              v-for="survey in surveyAttachments"
                              :key="survey.DownloadId"
                              :value="survey.DownloadId"
                            >
                              {{ survey.FileName }}
                            </option>
                          </select2>
                        </div>
                        <div class="col-md-1">
                          <button
                            id="checkManagementEditModalSelectSurveyToggle"
                            class="btn-edit"
                            type="button"
                            v-show="
                              this.generalSettingsData
                                .MaxSurveyInstanceStatusId <= 190
                            "
                            @click="
                              toggleBtn('checkManagementEditModalSelectSurvey');
                              return false;
                            "
                          >
                            <i class="material-icons">edit</i>
                          </button>
                        </div>
                      </div>
                      <div class="form-group fg-general-settings-input">
                        <label
                          for="inputCheckEditSurveyInstanceInfo"
                          class="col-md-4 control-label"
                          >{{ lang.CM1056 }}</label
                        >
                        <div class="col-md-7">
                          <input
                            type="text"
                            class="form-control"
                            maxlength="50"
                            id="inputCheckEditSurveyInstanceInfo"
                            v-model="generalSettingsData.SurveyInstanceInfo"
                            :disabled="
                              disabled.inputCheckEditSurveyInstanceInfo
                            "
                          />
                        </div>
                        <div class="col-md-1">
                          <button
                            id="inputCheckEditSurveyInstanceInfoToggle"
                            class="btn-edit"
                            type="button"
                            @click="
                              toggleBtn('inputCheckEditSurveyInstanceInfo');
                              return false;
                            "
                          >
                            <i class="material-icons">edit</i>
                          </button>
                        </div>
                      </div>
                      <div
                        v-show="generalSettingsData.SurveyInstanceType === 'FO'"
                      >
                        <div class="form-group fg-general-settings-input">
                          <label
                            for="inputCheckEditStartDate"
                            class="col-md-4 control-label"
                            >{{ lang.CM1040 }}</label
                          >
                          <div class="col-md-7">
                            <input
                              type="date"
                              class="form-control"
                              id="inputCheckEditStartDate"
                              v-model="generalSettingsData.SurveyInstanceSince"
                              :disabled="disabled.inputCheckEditStartDate"
                            />
                          </div>
                          <div class="col-md-1">
                            <button
                              id="inputCheckEditStartDateToggle"
                              class="btn-edit"
                              type="button"
                              v-show="
                                this.generalSettingsData
                                  .MaxSurveyInstanceStatusId <= 200
                              "
                              @click="
                                toggleBtn('inputCheckEditStartDate');
                                return false;
                              "
                            >
                              <i class="material-icons">edit</i>
                            </button>
                          </div>
                        </div>
                        <div class="form-group fg-general-settings-input">
                          <label
                            for="inputCheckEditEndDate"
                            class="col-md-4 control-label"
                            >{{ lang.CM1041 }}</label
                          >
                          <div class="col-md-7">
                            <input
                              type="date"
                              class="form-control"
                              id="inputCheckEditEndDate"
                              v-model="generalSettingsData.SurveyInstanceUntil"
                              :disabled="disabled.inputCheckEditEndDate"
                            />
                          </div>
                          <div class="col-md-1">
                            <button
                              id="inputCheckEditEndDateToggle"
                              class="btn-edit"
                              type="button"
                              v-show="
                                this.generalSettingsData
                                  .MaxSurveyInstanceStatusId <= 200
                              "
                              @click="
                                toggleBtn('inputCheckEditEndDate');
                                return false;
                              "
                            >
                              <i class="material-icons">edit</i>
                            </button>
                          </div>
                        </div>
                        <div class="form-group fg-general-settings-input">
                          <label
                            for="selectCheckEditSurveyInstanceSkillLevel"
                            class="col-md-4 control-label"
                            >{{ lang.CM1057 }}</label
                          >
                          <div class="col-md-7">
                            <select
                              class="form-control"
                              id="selectCheckEditSurveyInstanceSkillLevel"
                              @change="changeCounter()"
                              v-model.number="
                                generalSettingsData.SurveyInstanceSkillLevel
                              "
                              :disabled="
                                disabled.selectCheckEditSurveyInstanceSkillLevel
                              "
                            >
                              <option
                                :value="generalSettingsData.SurveySkillLevel"
                              >
                                {{ lang.CM1061 }}
                                <span
                                  >({{
                                    generalSettingsData.SurveySkillLevel
                                  }})</span
                                >
                              </option>
                              <option v-for="i in 5" :key="i">
                                {{ i }}
                              </option>
                            </select>
                          </div>
                          <div class="col-md-1">
                            <button
                              id="selectCheckEditSurveyInstanceSkillLevelToggle"
                              class="btn-edit"
                              type="button"
                              v-show="
                                this.generalSettingsData
                                  .MaxSurveyInstanceStatusId <= 200
                              "
                              @click="
                                toggleBtn(
                                  'selectCheckEditSurveyInstanceSkillLevel'
                                );
                                return false;
                              "
                            >
                              <i class="material-icons">edit</i>
                            </button>
                          </div>
                          <b-tooltip
                            target="selectCheckEditSurveyInstanceSkillLevel"
                            :delay="globals.tooltipDelay"
                            placement="right"
                            boundary="viewport"
                          >
                            1 &rarr; {{ lang.CM1058 }}
                            <br />
                            <br />...
                            <br />
                            <br />
                            5 &rarr; {{ lang.CM1059 }}
                          </b-tooltip>
                        </div>
                        <div class="form-group fg-general-settings-input">
                          <label class="col-md-4 control-label"></label>
                          <div class="col-md-4" id="onlineStatus">
                            <a
                              role="button"
                              class="btn btn-default btn-state"
                              @click="
                                () => {
                                  if (!disabled.onlineStatus) {
                                    generalSettingsData.IsReadonly ||
                                      toggleSettingNew('OnlineState');
                                    return false;
                                  }
                                }
                              "
                              :disabled="disabled.onlineStatus"
                            >
                              <i
                                class="material-icons md-24 text-primary"
                                v-if="generalSettingsData.OnlineState > 0"
                                >check_box</i
                              >
                              <i
                                class="material-icons md-24 text-primary"
                                v-else-if="generalSettingsData.OnlineState < 0"
                                >indeterminate_check_box</i
                              >
                              <i class="material-icons md-24" v-else
                                >check_box_outline_blank</i
                              >
                              <span>{{ lang.CM1042 }}</span>
                            </a>
                          </div>
                          <div class="col-md-3"></div>
                          <div class="col-md-1">
                            <button
                              id="onlineStatusToggle"
                              class="btn-edit"
                              type="button"
                              v-show="
                                this.generalSettingsData
                                  .MaxSurveyInstanceStatusId <= 200
                              "
                              @click="
                                toggleBtn('onlineStatus');
                                return false;
                              "
                            >
                              <i class="material-icons">edit</i>
                            </button>
                          </div>
                        </div>

                        <div class="form-group fg-general-settings-input">
                          <label class="col-md-4 control-label"></label>
                          <div class="col-md-4" id="locationFreeStatus">
                            <a
                              role="button"
                              class="btn btn-default btn-state"
                              @click="
                                () => {
                                  if (!disabled.locationFreeStatus) {
                                    generalSettingsData.IsReadonly ||
                                      toggleSettingNew('LocationFree');
                                    return false;
                                  }
                                }
                              "
                              :disabled="
                                generalSettingsData.IsReadonly ||
                                disabled.locationFreeStatus
                              "
                            >
                              <i
                                class="material-icons md-24 text-primary"
                                v-if="generalSettingsData.LocationFree > 0"
                                >check_box</i
                              >
                              <i
                                class="material-icons md-24 text-primary"
                                v-else-if="generalSettingsData.LocationFree < 0"
                                >indeterminate_check_box</i
                              >
                              <i class="material-icons md-24" v-else
                                >check_box_outline_blank</i
                              >
                              <span>{{ lang.CM1043 }}</span>
                            </a>
                          </div>
                          <div class="col-md-3"></div>
                          <div class="col-md-1">
                            <button
                              id="locationFreeToggle"
                              class="btn-edit"
                              type="button"
                              v-show="
                                this.generalSettingsData
                                  .MaxSurveyInstanceStatusId <= 200
                              "
                              @click="
                                toggleBtn('locationFreeStatus');
                                return false;
                              "
                            >
                              <i class="material-icons">edit</i>
                            </button>
                          </div>
                        </div>
                        <div class="form-group fg-general-settings-input">
                          <label class="col-md-4 control-label"></label>
                          <button
                            type="button"
                            class="btn btn-raised"
                            @click="openHtmlEditor()"
                            :disabled="generalSettingsData.IsReadonly"
                          >
                            {{ lang.CM1044 }}
                          </button>
                        </div>
                        <div class="form-group fg-general-settings-input">
                          <label class="col-md-4 control-label"></label>
                          <button
                            type="button"
                            class="btn btn-raised pull-left"
                            @click="openShopperFilterModal()"
                            :disabled="generalSettingsData.IsReadonly"
                          >
                            {{ lang.CM1053 }}
                          </button>
                        </div>
                      </div>
                      <div>
                        <div class="form-group fg-general-settings-input">
                          <!-- Internal note -->
                          <label
                            for="inputEditSurveyInstanceNote"
                            class="col-md-4 control-label"
                            >{{ lang.CM1052 }}</label
                          >
                          <div class="col-md-7">
                            <textarea
                              class="form-control"
                              rows="4"
                              maxlength="1000"
                              id="inputEditSurveyInstanceNote"
                              v-model="generalSettingsData.SurveyInstanceNote"
                              :disabled="disabled.inputEditSurveyInstanceNote"
                            ></textarea>
                          </div>
                          <div class="col-md-1">
                            <button
                              id="inputEditSurveyInstanceNoteToggle"
                              class="btn-edit"
                              type="button"
                              v-show="
                                this.generalSettingsData
                                  .MaxSurveyInstanceStatusId <= 200
                              "
                              @click="
                                toggleBtn('inputEditSurveyInstanceNote');
                                return false;
                              "
                            >
                              <i class="material-icons">edit</i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Accordion entry 2 -->
                <div
                  class="panel-heading"
                  role="button"
                  id="headingEditChecksSpecific"
                  data-toggle="collapse"
                  data-parent="#accordionEditChecks"
                  href="#collapseEditChecksSpecific"
                  aria-expanded="false"
                  aria-controls="collapseEditChecksSpecific"
                  v-if="
                    globals.isAccessAllowed(
                      'LoopOp_SurveyInstancesAnswers_Read'
                    ) && !generalSettingsData.IsReadonly
                  "
                >
                  <h4 class="panel-title">
                    <a class="collapsed">{{ lang.CM1017 }}</a>
                  </h4>
                </div>
                <div
                  id="collapseEditChecksSpecific"
                  class="panel-collapse collapse"
                  role="tabpanel"
                  aria-labelledby="headingEditChecksSpecific"
                  v-if="
                    globals.isAccessAllowed(
                      'LoopOp_SurveyInstancesAnswers_Read'
                    ) && !generalSettingsData.IsReadonly
                  "
                >
                  <div class="panel-body" style="padding: 15px">
                    <div class="col-md-4" id="checkListContainer">
                      <table class="table table-striped table-hover main-table">
                        <thead>
                          <tr>
                            <!-- Selected Checks -->
                            <th class="text-center">
                              {{ lang.CM1018 }}
                            </th>
                          </tr>
                        </thead>
                        <tbody
                          class="main-table-scrollbar"
                          id="check-list-table"
                        >
                          <tr
                            role="button"
                            v-for="(
                              check, key
                            ) in specificSettingsData.dataList"
                            :key="key"
                            @click="specificSettingsData.selectedCheck = check"
                            :class="{
                              info:
                                specificSettingsData.selectedCheck
                                  .SurveyInstanceGuid ===
                                check.SurveyInstanceGuid,
                            }"
                          >
                            <td>{{ check.SurveyInstanceId }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="col-md-8">
                      <div
                        class="shopper-info"
                        v-if="
                          specificSettingsData.selectedCheck.ApprovedShopper
                        "
                      >
                        <b>{{ lang.CM1068 }}:</b>
                        {{
                          specificSettingsData.selectedCheck.ApprovedShopper
                            .DisplayName
                        }}
                        <div id="approvedShopperDetailsContainer">
                          {{ lang.CM1069 }} ({{ lang.CM1070 }}):
                          {{
                            specificSettingsData.selectedCheck.ApprovedShopper
                              .ShopperAge
                          }}
                          ({{
                            specificSettingsData.selectedCheck.ApprovedShopper
                              .Gender
                          }})
                          <br />
                          {{ lang.CM1071 }}:
                          {{
                            specificSettingsData.selectedCheck.ApprovedShopper
                              .ShopperCar
                          }}
                          <br />
                          {{ lang.CM1072 }}:
                          {{
                            specificSettingsData.selectedCheck.ApprovedShopper
                              .CarSegmentName
                          }}
                          <br />
                          {{ lang.CM1073 }}:
                          {{
                            specificSettingsData.selectedCheck.ApprovedShopper
                              .CarModelName
                          }}
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputDateOfVisitCheckMgmtEdit"
                          class="col-md-4 control-label"
                          >{{ lang.CM1019 }}</label
                        >
                        <div class="col-md-8">
                          <input
                            type="date"
                            class="form-control specific-settings-data-input"
                            id="inputDateOfVisitCheckMgmtEdit"
                            v-model="
                              specificSettingsData.selectedCheck
                                .SurveyInstanceAnswerDateOfVisit
                            "
                            :disabled="
                              !globals.isAccessAllowed(
                                'LoopOp_SurveyInstancesAnswers_Update'
                              )
                            "
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputTimeInCheckMgmtEdit"
                          class="col-md-4 control-label"
                          >{{ lang.CM1020 }}</label
                        >
                        <div class="col-md-8">
                          <input
                            type="time"
                            class="form-control specific-settings-data-input"
                            id="inputTimeInCheckMgmtEdit"
                            v-model="
                              specificSettingsData.selectedCheck
                                .SurveyInstanceAnswerTimeIn
                            "
                            :disabled="
                              !globals.isAccessAllowed(
                                'LoopOp_SurveyInstancesAnswers_Update'
                              )
                            "
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputTimeOutCheckMgmtEdit"
                          class="col-md-4 control-label"
                          >{{ lang.CM1021 }}</label
                        >
                        <div class="col-md-8">
                          <input
                            type="time"
                            class="form-control specific-settings-data-input"
                            id="inputTimeOutCheckMgmtEdit"
                            v-model="
                              specificSettingsData.selectedCheck
                                .SurveyInstanceAnswerTimeOut
                            "
                            :disabled="
                              !globals.isAccessAllowed(
                                'LoopOp_SurveyInstancesAnswers_Update'
                              )
                            "
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputMemoShopper"
                          class="col-md-4 control-label"
                          >{{ lang.CM1022 }}</label
                        >
                        <div class="col-md-8">
                          <textarea
                            class="form-control specific-settings-data-input"
                            rows="4"
                            id="inputMemoShopper"
                            v-model="
                              specificSettingsData.selectedCheck
                                .SurveyInstanceAnswerMemoShopper
                            "
                            :disabled="
                              !globals.isAccessAllowed(
                                'LoopOp_SurveyInstancesAnswers_Update'
                              )
                            "
                          ></textarea>
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputMemoAgency"
                          class="col-md-4 control-label"
                          >{{ lang.CM1023 }}</label
                        >
                        <div class="col-md-8">
                          <textarea
                            class="form-control specific-settings-data-input"
                            rows="4"
                            id="inputMemoAgency"
                            v-model="
                              specificSettingsData.selectedCheck
                                .SurveyInstanceAnswerMemoAgency
                            "
                            :disabled="
                              !globals.isAccessAllowed(
                                'LoopOp_SurveyInstancesAnswers_Update'
                              )
                            "
                          ></textarea>
                        </div>
                      </div>
                      <div class="form-group" v-if="!feature.isAudiTarget">
                        <label
                          for="inputMemoMSM"
                          class="col-md-4 control-label"
                          >{{ lang.CM1024 }}</label
                        >
                        <div class="col-md-8">
                          <textarea
                            class="form-control specific-settings-data-input"
                            rows="4"
                            id="inputMemoMSM"
                            v-model="
                              specificSettingsData.selectedCheck
                                .SurveyInstanceAnswerMemoMSM
                            "
                            :disabled="
                              !globals.isAccessAllowed(
                                'LoopOp_SurveyInstancesAnswers_Update'
                              )
                            "
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Accordion entry 3 -->
                <div
                  class="panel-heading"
                  role="button"
                  id="headingEditChecksControlling"
                  data-toggle="collapse"
                  data-parent="#accordionEditChecks"
                  href="#collapseEditChecksControlling"
                  aria-expanded="false"
                  aria-controls="collapseEditChecksControlling"
                  v-if="feature.isMSMGermanyTarget"
                >
                  <h4 class="panel-title">
                    <a class="collapsed">Controlling Settings</a>
                  </h4>
                </div>
                <div
                  id="collapseEditChecksControlling"
                  class="panel-collapse collapse"
                  role="tabpanel"
                  aria-labelledby="headingEditChecksControlling"
                  v-if="feature.isMSMGermanyTarget"
                >
                  <div class="panel-body" style="padding: 15px">
                    <div
                      class="col-md-4 container-scrollbar"
                      id="controllingCheckListContainer"
                    >
                      <table class="table table-striped table-hover main-table">
                        <thead>
                          <tr>
                            <!-- Selected Checks -->
                            <th class="text-center">
                              {{ lang.CM1018 }}
                            </th>
                          </tr>
                        </thead>
                        <tbody
                          class="main-table-scrollbar"
                          id="controlling-check-list-table"
                        >
                          <tr
                            role="button"
                            v-for="(
                              check, key
                            ) in controllingSettingsData.dataList"
                            :key="key"
                            @click="
                              controllingSettingsData.selectedCheck = check
                            "
                            :class="{
                              info:
                                controllingSettingsData.selectedCheck
                                  .SurveyInstanceGuid ===
                                check.SurveyInstanceGuid,
                            }"
                          >
                            <td>{{ check.SurveyInstanceId }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <!-- SUBPROJECT SELECT -->
                    <div class="form-group">
                      <label
                        for="check-management-edit-subprojects"
                        class="col-md-4 control-label"
                        >Subproject</label
                      >
                      <div class="col-md-8">
                        <select2
                          id="check-management-edit-subprojects"
                          v-model="
                            controllingSettingsData.selectedCheck.SubProjectId
                          "
                          :key="
                            controllingSettingsData.selectedCheck.SubProjectId
                          "
                          placeholder="Select Subproject"
                          :allowClear="true"
                          :afterChange="controllSettingDataChanged"
                        >
                          <option
                            v-for="subProject in filteredSubProjects"
                            :key="subProject.SubProjectId"
                            :value="subProject.SubProjectId"
                          >
                            {{ subProject.SubProjectName }}
                          </option>
                        </select2>
                      </div>
                    </div>
                    <!-- ORDER SELECT -->
                    <div class="form-group">
                      <label
                        for="check-management-edit-order"
                        class="col-md-4 control-label"
                        >Order</label
                      >
                      <div class="col-md-8">
                        <select2
                          id="check-management-edit-order"
                          v-model="
                            controllingSettingsData.selectedCheck.OrderId
                          "
                          :key="controllingSettingsData.selectedCheck.OrderId"
                          placeholder="Select Order"
                          :allowClear="true"
                          :afterChange="controllSettingDataChanged"
                        >
                          <option
                            v-for="order in filteredOrders"
                            :key="order.OrderId"
                            :value="order.OrderId"
                          >
                            {{ order.OrderName }}
                          </option>
                        </select2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <!-- Add modal buttons here -->
            <button
              type="button"
              class="btn btn-raised btn-default"
              data-dismiss="modal"
            >
              {{ lang.CM1025 }}
            </button>
            <button
              type="button"
              class="btn btn-raised dialog-btn-primary"
              @click="saveEditCheckDialogData()"
              :disabled="disableSaveButton && !shopperFilterDataDirty"
            >
              {{ lang.CM1026 }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from "../Tools/Select2";

import generalSettingsData from "./generalSettingsData";

export default {
  name: "CheckManagementEditModal",
  components: {
    Select2,
  },
  props: [
    "dataLists",
    "selectedChecks",
    "selectedCheckIds",
    "selectedClient",
    "selectedProject",
    "includeChecks",
    "showDialog",
    "projectSelected",
  ],
  data() {
    // Global data inside the component is stored here
    return {
      loading: false,
      listenForSettlementChanges: false,
      ChangesCounter: 0,
      checkData: {}, // The check data of the selected check is stored here
      generalSettingsData: generalSettingsData,
      surveyInstanceDescriptionMixed: false,
      WaveAndScenarioChangedAfterLoading: false,
      surveyInstanceInfoMixed: false,
      specificSettingsData: {
        selectedCheck: {},
        dataList: [],
      },
      disabled: {
        inputCustomReportingDateCheckMgmtEdit: true,
        inputEditSurveyInstanceNote: true,
        selectCheckEditSurveyInstanceSkillLevel: true,
        inputCheckEditEndDate: true,
        inputCheckEditStartDate: true,
        inputCheckEditSurveyInstanceInfo: true,
        checkManagementEditModalSelectSurvey: true,
        checkManagementEditModalSelectBriefing: true,
        checkManagementEditModalSelectLocation: true,
        checkManagementEditModalSelectScenario: true,
        checkManagementEditModalSelectWave: true,
        checkManagementEditModalSelectAgency: true,
        checkManagementEditModalSelectLocalAgency: true,
        checkManagementEditModalSelectLeadAgency: true,
        checkManagementEditModalSelectUser: true,
        checkManagementEditModalSelectSurveyInstanceType: true,
        inputCustomReportingDateCheckMgmtEdit: true,
        locationFreeStatus: true,
        onlineStatus: true,
      },
      internalNoteForAllChecks: false,
      shopperFilter: {},
      shopperFilterDataDirty: false,
      scenarioList: [],
      wavesOfProject: [],
      scenariosOfWave: [],
      locationsOfSelectedClient: [],
      briefingAttachments: [],
      surveyAttachments: [],
      previousLocationGuid: "",
      languageStringsReceived: false,
      lang: {
        CM1000: "Edit Checks",
        CM1001: "General Settings",
        CM1002: "Visible in Notification",
        CM1003: "External Interface",
        CM1004: "Visible for location notification",
        CM1005: "Query Tool",
        CM1006: "Dashboard",
        CM1007: "Check Explorer",
        CM1008: "Aggregated Report",
        CM1009: "Raw Data Exports",
        CM1010: "Frequencies",
        CM1011: "Media Explorer",
        CM1012: "Type of Mail",
        CM1013: "Custom Reporting Date",
        CM1014: "Scenario",
        CM1015: "User",
        CM1016: "Agency",
        CM1017: "Check Specific Settings",
        CM1018: "Selected Checks",
        CM1019: "Date of Visit",
        CM1020: "Time In",
        CM1021: "Time Out",
        CM1022: "Memo Shopper",
        CM1023: "Memo Agency",
        CM1024: "Memo MSM",
        CM1025: "Cancel",
        CM1026: "Save",
        CM1027: "Check Description",
        CM1028: "Wave",
        CM1029: "Location",
        CM1030: "Location changed",
        CM1031: "Yes",
        CM1032: "No",
        CM1033:
          "ATTENTION: Changing the location may impact filters inside the check. Do you really want to change the location?",
        CM1034: "Briefing",
        CM1035: "Survey",
        CM1036: "Check type",
        CM1037: "Free offer",
        CM1038: "Manual assignment",
        CM1039: "Agency",
        CM1040: "Begin",
        CM1041: "End",
        CM1042: "Online",
        CM1043: "Location free",
        CM1044: "Edit offer description",
        CM1045: "Check property access failed",
        CM1046: "No agency selected",
        CM1047: "No user selected",
        CM1048: "Check property update successful",
        CM1049: "Check property update failed",
        CM1050: "Attachment data access failed",
        CM1051: "Offer description",
        CM1052: "Internal note",
        CM1053: "Shopper filter",
        CM1054: "Shopper filter request failed",
        CM1055: "Shopper filter update failed",
        CM1056: "Check Info",
        CM1057: "Difficulty",
        CM1058: "simple",
        CM1059: "difficult",
        CM1060: "End date before start date",
        CM1061: "Inherit from survey",
        CM1062: "Combined filters",
        CM1063: "OK",
        CM1064:
          "Due to the selection of multiple checks there are lots of possible filter combinations that could not be represented in this view. In this case an empty filter appears.",
        CM1065:
          "Nevertheless it's possible to define a new filter for all selected checks. Already existing filters will be overwritten.",
        CM1066: "Lead agency",
        CM1067: "Local agency",
        CM1068: "Shopper",
        CM1069: "Age",
        CM1070: "Gender",
        CM1071: "Car",
        CM1072: "Target segment",
        CM1073: "Target model",
        CM1074: "Check template - self creating check",
        CM1075: "self creating check",
        CM1076: "Use internal note for all checks",
        CM1077: "CX Reporting",
        CM1078: "Order data access failed"
      },
      controllingSettingsData: {
        dataList: null,
        selectedCheck: {},
      },
      orders: null,
      subProjects: null,
      selectedSubProject: null,
    };
  },
  mounted() {
    if (this.globals.selectedLanguage) {
      this.languageStringsReceived = false;
      this.globals.getLanguageStrings(this, () => {
        this.languageStringsReceived = true;
      });
    }

    $("#editChecksDialog").on("hidden.bs.modal", (e) => {
      this.$emit("dialogClosed");
    });

    if (this.feature.isAudiTarget && this.feature.isEnabled("leadAgencies")) {
      this.globals.getAgencyTypeList((data) => {
        this.agencyTypeList = data;
      });
    }
  },
  computed: {
    leadAgencyGuid() {
      if (this.agencyTypeList.length < 1) return "";
      let leadAgency = _.find(
        this.agencyTypeList,
        (at) => at.AgencyTypeName === "Lead"
      );
      return leadAgency ? leadAgency.AgencyTypeGuid : "";
    },
    leadAgencies() {
      if (!this.leadAgencyGuid) return [];
      return this.dataLists.agencyList.filter(
        (a) => a.AgencyTypeGuid === this.leadAgencyGuid
      );
    },
    localAgencies() {
      if (
        !this.generalSettingsData.SurveyInstanceAssignedLeadAgencyGuid ||
        this.leadAgencies.length < 1
      )
        return [];

      let lead = this.leadAgencies.find(
        (a) =>
          a.AgencyGuid ===
          this.generalSettingsData.SurveyInstanceAssignedLeadAgencyGuid
      );
      if (this.$refs.checkEditSelectLocalAgency)
        this.$refs.checkEditSelectLocalAgency.updateValue();
      return lead && lead.ChildAgencies ? lead.ChildAgencies : [];
    },
    filteredSubProjects() {
      if (!this.controllingSettingsData.selectedCheck || !this.subProjects)
        return [];
      return this.subProjects.filter(
        (sp) =>
          sp.ProjectGuid ===
          this.controllingSettingsData.selectedCheck.ProjectGuid
      );
    },
    filteredOrders() {
      if (
        (!this.controllingSettingsData.selectedCheck &&
          !this.controllingSettingsData.selectedCheck.SubProjectId) ||
        !this.subProjects ||
        !this.orders
      )
        return [];
      return this.orders.filter(
        (o) =>
          o.SubProjectId ==
          this.controllingSettingsData.selectedCheck.SubProjectId
      );
    },
    disableSaveButton() {
      if (
        !this.globals.isAccessAllowed("LoopOp_SurveyInstancesProperties_Update")
      ) {
        return true;
      } else {
        // disable button, because it is impossible to have changes and ChangesCounter is 0
        if (this.ChangesCounter === 0) return true;

        // it is not allowed to save if there invalid entries, in wave or scenario field after changing scenario or wave
        if (
          this.WaveAndScenarioChangedAfterLoading &&
          !this.disabled.checkManagementEditModalSelectScenario &&
          !this.disabled.checkManagementEditModalSelectWave &&
          (!this.generalSettingsData.SurveyInstanceWaveGuid ||
            !this.generalSettingsData.SurveyInstanceScenarioGuid ||
            this.generalSettingsData.SurveyInstanceScenarioGuid == "" ||
            this.generalSettingsData.SurveyInstanceScenarioGuid == "-1" ||
            this.generalSettingsData.SurveyInstanceWaveGuid == "")
        )
          return true;
      }
    },
  },
  methods: {
    SurveyInstanceWaveGuidChanged() {
      this.getScenariosOfWave();
      if (
        _.findIndex(this.scenariosOfWave, (o) => {
          return (
            o.ScenarioGuid ==
            this.generalSettingsData.SurveyInstanceScenarioGuid
          );
        }) < 0
      ) {
        this.generalSettingsData.SurveyInstanceScenarioGuid = "";
      }
    },
    SurveyInstanceAssignedLocalAgencyGuidChanged() {
      //this.generalSettingsData.SurveyInstanceAssignedShopperGuid = null;
    },
    SurveyInstanceAssignedLeadAgencyGuidChanged() {
      this.generalSettingsData.SurveyInstanceAssignedShopperGuid = null;
      this.generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid = null;
    },
    SurveyInstanceShopperChanged() {
      if (
        this.generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid &&
        this.generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid.length >
          5
      ) {
        this.generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid = "";
        this.SurveyInstanceAssignedLocalAgencyGuidChanged = true;
      } else if (this.SurveyInstanceAssignedLocalAgencyGuidChanged === false)
        this.generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid = "-1";
      if (
        this.generalSettingsData.SurveyInstanceAssignedLeadAgencyGuid &&
        this.generalSettingsData.SurveyInstanceAssignedLeadAgencyGuid.length > 5
      ) {
        this.generalSettingsData.SurveyInstanceAssignedLeadAgencyGuid = "";
        this.SurveyInstanceAssignedLeadAgencyGuidChanged = true;
      } else if (this.SurveyInstanceAssignedLeadAgencyGuidChanged === false)
        this.generalSettingsData.SurveyInstanceAssignedLeadAgencyGuid = "-1";
    },
    surveyInstanceTypeChanged(value) {
      this.generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid = null;
      //this.generalSettingsData.SurveyInstanceAssignedShopperGuid = null;
      if (value === "AG") {
        if (
          this.generalSettingsData.surveyInstanceAssignedShopperGuid &&
          this.generalSettingsData.surveyInstanceAssignedShopperGuid.length > 5
        )
          this.generalSettingsData.surveyInstanceAssignedShopperGuid = "";
      }
      if (value === "FO") {
        if (typeof this.generalSettingsData.LocationFree !== "number")
          this.generalSettingsData.LocationFree = 0;
        if (typeof this.generalSettingsData.OnlineState !== "number")
          this.generalSettingsData.OnlineState = 0;
      }
    },
    controllSettingDataChanged(value) {
      if (this.listenForSettlementChanges) {
        this.ChangesCounter++;
      }
    },
    convertScenarioList() {
      this.scenarioList = [];
      for (let i = 0; i < this.dataLists.scenarioList.length; i++) {
        this.scenarioList = _.union(
          this.scenarioList,
          this.dataLists.scenarioList[i].Scenarios
        );
      }
    },
    openShopperFilterModal() {
      this.globals.$emit("openShopperFilterModal");
      this.globals.$emit("sendDataToShopperFilterModal", this.shopperFilter);
      if (
        !this.$multipleCheckFilterMessageShown &&
        this.selectedChecks.length > 1
      ) {
        this.$multipleCheckFilterMessageShown = true;
        setTimeout(() => {
          this.globals.$emit("openGlobalNotificationDialog", {
            initiator: "CheckManagementEditModalOpenShopperFilter",
            notificationTitle: this.lang.CM1062,
            closeButtonText: this.lang.CM1063,
            htmlText: `<p>${this.lang.CM1064}<br><br>${this.lang.CM1065}</p>`,
          });
        }, 200);
      }
    },
    //Toggle Buttons
    toggleBtn(btnID) {
      const stateBefore = _.cloneDeep(this.disabled[btnID]);
      if (
        !this.generalSettingsData.IsReadonly &&
        this.generalSettingsData.MaxSurveyInstanceStatusId <= 200
      ) {
        this.disabled[btnID] = !this.disabled[btnID];
      }

      //For audi if InstanceStatusId > 50
      if (
        (btnID == "checkManagementEditModalSelectLeadAgency" &&
          this.feature.isAudiTarget &&
          this.generalSettingsData.MaxSurveyInstanceStatusId > 50) ||
        (this.generalSettingsData.IsReadonly &&
          btnID != "inputCheckEditSurveyInstanceInfo")
      ) {
        this.disabled[btnID] = true;
      }

      //If Status > 190 or LocationGUID == "-1" disable Location
      else if (
        btnID == "checkManagementEditModalSelectLocation" &&
        (this.generalSettingsData.IsReadonly ||
          this.generalSettingsData.MaxSurveyInstanceStatusId > 190 ||
          this.generalSettingsData.SurveyInstanceLocationGuid === "-1")
      )
        this.disabled[btnID] = true;
      //If Status > 190 or BriefingDownloadGUID == "-1" disable
      else if (
        btnID == "checkManagementEditModalSelectBriefing" &&
        (this.generalSettingsData.IsReadonly ||
          this.generalSettingsData.MaxSurveyInstanceStatusId > 190 ||
          this.generalSettingsData.BriefingDownloadGuid === "-1")
      )
        this.disabled[btnID] = true;
      //If Status > 190 or SurveyDownloadGUID == "-1" disable
      else if (
        btnID == "checkManagementEditModalSelectSurvey" &&
        (this.generalSettingsData.IsReadonly ||
          this.generalSettingsData.MaxSurveyInstanceStatusId > 190 ||
          this.generalSettingsData.SurveyDownloadGuid === "-1")
      )
        this.disabled[btnID] = true;
      //If isAccessAllowed
      else if (
        btnID == "inputEditSurveyInstanceNote" &&
        !this.globals.isAccessAllowed("LoopOp_SurveyInstancesAnswers_Update")
      )
        this.disabled[btnID] = true;
      // CheckInfo field should be always editable: #1932
      else if (btnID == "inputCheckEditSurveyInstanceInfo") {
        this.disabled[btnID] = !stateBefore;
      }

      this.$forceUpdate();
    },

    //toggleSettings new
    toggleSettingNew(setting) {
      if (this.generalSettingsData[setting] == 1)
        this.generalSettingsData[setting] = 0;
      else this.generalSettingsData[setting] = 1;

      this.$forceUpdate();
    },
    //toggleSettings old
    toggleSetting(setting) {
      // XOR flip the bit
      this.generalSettingsData[setting] = this.generalSettingsData[setting] ^ 1;
      this.$forceUpdate();
    },
    /**
     * Apply the internal note from specificSettings to all (selected) checks, if the relevant checkbox is true
     * @param {string} InstanceNote
     */
    applyInstanceNoteForAll(InstanceNote) {
      if (this.internalNoteForAllChecks) {
        for (let check of this.specificSettingsData.dataList) {
          check.SurveyInstanceNote = InstanceNote;
        }
      }
    },
    // Fills the editCheck dialog with data, depending on the dialog mode.
    async openEditChecksDialog() {
      console.debug("openEditChecksDialog - triggered");
      if (
        this.feature.currentTarget != "dev" &&
        this.globals.isAccessAllowed("LoopOp_SurveyInstances_Create") &&
        this.feature.isMSMGermanyTarget
      ) {
        this.getOrders();
        this.getSubProjects();
      }

      this.ChangesCounter = 0;
      this.listenForSettlementChanges = false;

      try {        
        await this.getCheckSpecificData();
      } catch (error) {
        console.error("Error on -> await this.getCheckSpecificData", error);
      }

      try {        
        await this.globals.$on("getDataFromShopperFilterModal", (data) => {
          if (_.isEqual(this.shopperFilter, data)) return;
          this.shopperFilter = data;
          this.shopperFilterDataDirty = true;
        });
      } catch (error) {
        console.error('Error on -> await this.globals.$on("getDataFromShopperFilterModal"', error);
      }

      try {        
        if (this.$clientChanged) {
          await this.getLocationsOfSelectedClient();
          delete this.$clientChanged;
        }
      } catch (error) {
        console.error('Error on -> await this.getLocationsOfSelectedClient()', error);
      }

      try {        
        if (this.feature.currentTarget != "dev" && this.feature.isMSMGermanyTarget) {
          await this.getSurveyInstanceOrderIds();
        }
      } catch (error) {
        console.error('Error on -> await this.getSurveyInstanceOrderIds()', error);
      }

      this.convertScenarioList();
      this.getWavesOfProject();
      this.getProjectAttachments();

      this.checkData = { Surveys: [] };
      this.loading = true;
      $.ajax({
        method: "POST",
        url: "api/SurveyInstances/Properties?include=" + this.includeChecks,
        data: JSON.stringify(this.selectedCheckIds),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          console.debug("openEditChecksDialog - POST success", data);
          if (data.Error) {
            this.globals.showErrorSnackbar(data.Error);
            this.$emit("dialogClosed");
          } else {
            // SurveyInstanceNotes comes from api/SurveyInstances/Properties/DetailsList
            let tmpSurveyInstanceNote = "";

            if (
              this.generalSettingsData.SurveyInstanceNote //&&
              //this.generalSettingsData.SurveyInstanceNote !== ""
            ) {
              tmpSurveyInstanceNote =
                this.generalSettingsData.SurveyInstanceNote;
            }
            this.generalSettingsData.setData(data);

            if (data.SurveyInstanceSkillLevel)
              this.generalSettingsData.SurveyInstanceSkillLevel =
                data.SurveyInstanceSkillLevel;
            else
              this.generalSettingsData.SurveyInstanceSkillLevel =
                this.generalSettingsData.SurveySkillLevel;

            if (data.LocationFree)
              this.generalSettingsData.LocationFree = data.LocationFree;
            else this.generalSettingsData.LocationFree = "-1";
            if (data.OnlineState)
              this.generalSettingsData.OnlineState = data.OnlineState;
            else this.generalSettingsData.OnlineState = "-1";
            if (data.SurveyInstanceSince)
              this.generalSettingsData.SurveyInstanceSince =
                data.SurveyInstanceSince.split("T")[0];
            else this.generalSettingsData.SurveyInstanceSince = "-1";
            if (data.SurveyInstanceUntil)
              this.generalSettingsData.SurveyInstanceUntil =
                data.SurveyInstanceUntil.split("T")[0];
            else this.generalSettingsData.SurveyInstanceUntil = "-1";
            if (data.SurveyInstanceCustomReportingDate)
              this.generalSettingsData.SurveyInstanceCustomReportingDate =
                data.SurveyInstanceCustomReportingDate.split("T")[0];
            else
              this.generalSettingsData.SurveyInstanceCustomReportingDate = "-1";
            if (tmpSurveyInstanceNote !== "") {
              this.generalSettingsData.SurveyInstanceNote =
                tmpSurveyInstanceNote;
            }
            this.previousLocationGuid = data.SurveyInstanceLocationGuid;
            this.getShopperFilterObject();

            if (data.SurveyInstanceDescription === "-1") {
              this.generalSettingsData.SurveyInstanceDescription = "";
              this.surveyInstanceDescriptionMixed = true;
            }
            if (data.SurveyInstanceInfo === "-1") {
              this.generalSettingsData.SurveyInstanceInfo = "";
              this.surveyInstanceInfoMixed = true;
            }

            // this.$nextTick(() => {
            $("#checkManagementEditModalSelectAgency").val(
              this.generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid
            );
            $("#checkManagementEditModalSelectUser").val(
              this.generalSettingsData.SurveyInstanceAssignedShopperGuid
            );

            if (this.$refs.checkEditSelectLeadAgency)
              this.$refs.checkEditSelectLeadAgency.updateValue();

            if (!this.generalSettingsData.BriefingDownloadGuid)
              this.generalSettingsData.BriefingDownloadGuid = "";
            if (!this.generalSettingsData.SurveyDownloadGuid)
              this.generalSettingsData.SurveyDownloadGuid = "";
            // });

            $("#editChecksDialog").modal("show");
            this.globals.$off("getDataFromHtmlEditorModal");
            this.globals.$on("getDataFromHtmlEditorModal", (data) => {
              this.generalSettingsData.SurveyInstanceDescription = data;
            });

            this.$nextTick(() => {
              // Event listener for changes on generalSettingsData
              this.generalSettingsData.onChange((propertyName, value) => {
                if (
                  (propertyName === "SurveyInstanceScenarioGuid" ||
                    propertyName === "SurveyInstanceWaveGuid") &&
                  value != "-1"
                ) {
                  this.WaveAndScenarioChangedAfterLoading = true;
                }
                this.ChangesCounter++;
              });
              // Event listener for changes on specificSettingsData
              $(".specific-settings-data-input").on("change input", () => {
                this.ChangesCounter++;
              });

              // Event listener for changes on custom reporitn date
              $(".custom-reporting-date-input").on("change input", () => {
                this.ChangesCounter++;
              });

              this.listenForSettlementChanges = true;
            });
          }
        },
        error: () => {
          console.error("Check data access failed in openEditChecksDialog()");
          this.globals.showErrorSnackbar(this.lang.CM1045);
          this.$emit("dialogClosed");
        },
        complete: (res) => {
          this.loading = false;
        },
      });
    },
    // Closes the editChecksDialog
    closeEditChecksDialog() {
      this.globals.$off("getDataFromShopperFilterModal");
      this.generalSettingsData.valueChangedCallback = null;
      Object.keys(this.disabled).forEach((key) => {
        this.disabled[key] = true;
      });

      $("#editChecksDialog").modal("hide");
    },
    getShopperFilterObject() {
      if (
        this.generalSettingsData.SurveyInstanceType !== "FO" ||
        this.selectedChecks.length > 1
      ) {
        this.shopperFilter = {};
        this.shopperFilterDataDirty = false;
        return;
      }

      let url = `api/SurveyInstances/ShopperFilter/${this.selectedChecks[0]}`;
      $.ajax({
        method: "GET",
        url: url,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          this.shopperFilter =
            data && data.ShopperFilter ? data.ShopperFilter : {};
          this.shopperFilterDataDirty = false;
        },
        error: () => {
          console.error("Error on GET in getShopperFilterObject()");
          this.globals.showErrorSnackbar(this.lang.CM1054);
          this.$emit("dialogClosed");
        },
      });
    },
    saveShopperFilterObject() {
      if (!this.shopperFilterDataDirty) return;
      let url = `api/SurveyInstances/ShopperFilter`;
      let sendData = {
        SurveyInstanceGuids: this.selectedChecks,
        ShopperFilter: this.shopperFilter,
      };

      $.ajax({
        method: "PUT",
        url: url,
        data: JSON.stringify(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          this.shopperFilterDataDirty = false;
        },
        error: () => {
          console.error("Error on PUT in saveShopperFilterObject()");
          this.globals.showErrorSnackbar(this.lang.CM1055);
        },
      });
    },
    changeCounter() {
      this.ChangesCounter++;
    },

    // Sends the data from editCheck dialog to the server to store it in the database
    saveEditCheckDialogData() {
      this.saveShopperFilterObject();
      this.saveCheckSpecificData();
      this.saveCheckControllingData();

      /* if (
        this.generalSettingsData.SurveyInstanceType === "AG" &&
        !this.generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid &&
        !this.feature.isAudiTarget
      ) {
        this.globals.showErrorSnackbar(this.lang.CM1046);
        return;
      }
      if (
        this.generalSettingsData.SurveyInstanceType === "MA" &&
        !this.generalSettingsData.SurveyInstanceAssignedShopperGuid
      ) {
        this.globals.showErrorSnackbar(this.lang.CM1047);
        return;
      }*/
      if (
        this.generalSettingsData.SurveyInstanceSince &&
        this.generalSettingsData.SurveyInstanceSince !== "-1" &&
        this.generalSettingsData.SurveyInstanceUntil &&
        this.generalSettingsData.SurveyInstanceUntil !== "-1" &&
        this.generalSettingsData.SurveyInstanceSince >
          this.generalSettingsData.SurveyInstanceUntil
      ) {
        this.globals.showErrorSnackbar(this.lang.CM1060);
        return;
      }

      let sendData = _.cloneDeep(this.generalSettingsData);

      //If disabled set sendData to "-1"

      if (this.disabled.inputCustomReportingDateCheckMgmtEdit)
        sendData.SurveyInstanceCustomReportingDate = "-1";

      if (this.disabled.checkManagementEditModalSelectSurveyInstanceType)
        sendData.SurveyInstanceType = "-1";

      if (
        this.disabled.checkManagementEditModalSelectUser &&
        this.generalSettingsData.SurveyInstanceType !== "AG"
      )
        sendData.SurveyInstanceAssignedShopperGuid = "-1";

      if (document.getElementById("checkManagementEditModalSelectLeadAgency")) {
        if (this.disabled.checkManagementEditModalSelectLeadAgency)
          sendData.SurveyInstanceAssignedLeadAgencyGuid = "-1";
        sendData.SurveyInstanceAssignedLeadAgencyGuidChanged = "-1";
      }

      if (
        document.getElementById("checkManagementEditModalSelectLocalAgency")
      ) {
        if (this.disabled.checkManagementEditModalSelectLocalAgency)
          sendData.SurveyInstanceAssignedLocalAgencyGuid = "-1";
      }

      if (document.getElementById("checkManagementEditModalSelectAgency")) {
        if (
          this.disabled.checkManagementEditModalSelectAgency &&
          sendData.SurveyInstanceAssignedLocalAgencyGuid == null
        ) {
          sendData.SurveyInstanceAssignedLocalAgencyGuid = "-1";
          sendData.SurveyInstanceAssignedLeadAgencyGuid = "-1";
        }
      }

      if (document.getElementById("checkManagementEditModalSelectWave")) {
        if (this.disabled.checkManagementEditModalSelectWave)
          sendData.SurveyInstanceWaveGuid = "-1";
      }

      if (document.getElementById("checkManagementEditModalSelectScenario")) {
        if (this.disabled.checkManagementEditModalSelectScenario)
          sendData.SurveyInstanceScenarioGuid = "-1";
      }

      if (document.getElementById("checkManagementEditModalSelectLocation")) {
        if (this.disabled.checkManagementEditModalSelectLocation)
          sendData.SurveyInstanceLocationGuid = "-1";
      }

      if (document.getElementById("checkManagementEditModalSelectBriefing")) {
        if (this.disabled.checkManagementEditModalSelectBriefing)
          sendData.BriefingDownloadGuid = "-1";
      }

      if (document.getElementById("checkManagementEditModalSelectSurvey")) {
        if (this.disabled.checkManagementEditModalSelectSurvey)
          sendData.SurveyDownloadGuid = "-1";
      }

      if (document.getElementById("inputCheckEditSurveyInstanceInfo")) {
        if (this.disabled.inputCheckEditSurveyInstanceInfo)
          sendData.SurveyInstanceInfo = "-1";
      }

      if (document.getElementById("inputCheckEditStartDate")) {
        if (this.disabled.inputCheckEditStartDate)
          sendData.SurveyInstanceSince = "-1";
      }

      if (document.getElementById("inputCheckEditEndDate")) {
        if (this.disabled.inputCheckEditEndDate)
          sendData.SurveyInstanceUntil = "-1";
      }

      if (document.getElementById("selectCheckEditSurveyInstanceSkillLevel")) {
        if (this.disabled.selectCheckEditSurveyInstanceSkillLevel)
          sendData.SurveyInstanceSkillLevel = "-1";
      }

      if (document.getElementById("inputEditSurveyInstanceNote")) {
        if (this.disabled.inputEditSurveyInstanceNote)
          sendData.SurveyInstanceNote = "-1";
      }

      if (document.getElementById("onlineStatus")) {
        if (this.disabled.onlineStatus) {
          sendData.OnlineState = -1;
        }
      }

      if (document.getElementById("locationFreeStatus")) {
        if (this.disabled.locationFreeStatus) {
          sendData.LocationFree = -1;
        }
      }

      //#1794 Fix for Agency with multi check selected
      if (!sendData.SurveyInstanceAssignedLeadAgencyGuid)
        sendData.SurveyInstanceAssignedLeadAgencyGuid = "-1";
      sendData.SurveyInstanceIds = this.selectedCheckIds;
      if (
        this.surveyInstanceDescriptionMixed &&
        !sendData.SurveyInstanceDescription
      ) {
        sendData.SurveyInstanceDescription = "-1";
      }
      this.surveyInstanceDescriptionMixed = false;
      if (this.surveyInstanceInfoMixed && !sendData.SurveyInstanceInfo) {
        sendData.SurveyInstanceInfo = "-1";
      }
      this.surveyInstanceInfoMixed = false;

      if (!sendData.SurveyInstanceCustomReportingDate)
        delete sendData.SurveyInstanceCustomReportingDate;

      $.ajax({
        method: "PUT",
        url: "api/SurveyInstances/Properties?include=" + this.includeChecks,
        data: JSON.stringify(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) {
            this.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }
          this.globals.showSuccessSnackbar(this.lang.CM1048);
          this.$emit("dialogDataSaved");
          this.closeEditChecksDialog();
        },
        error: () => {
          console.error("Error on PUT in saveEditCheckDialogData()");
          this.globals.showErrorSnackbar(this.lang.CM1049);
        },
      });
    },
    /** Check if the SurveyInstancesNotes (internal notes) of all selected SurveyInstances are the same
     * @param surveyInstanceList contains list of surveyinstances comming from "api/SurveyInstances/Properties/DetailsList"
     */
    hasSameSurveyInstanceNote(surveyInstanceList) {
      if (surveyInstanceList.length == 1) {
        return true;
      } else if (surveyInstanceList.length == 0) {
        return false;
      }

      let firstNote = "";
      for (let i = 0; i < surveyInstanceList.length; i++) {
        if (
          surveyInstanceList[i].SurveyInstanceNote &&
          surveyInstanceList[i].SurveyInstanceNote != ""
        ) {
          if (i === 0) {
            firstNote = surveyInstanceList[i].SurveyInstanceNote;
          } else {
            if (surveyInstanceList[i].SurveyInstanceNote !== firstNote) {
              return false;
            }
          }
        } else {
          return false;
        }
      }

      return true;
    },
    getCheckSpecificData() {
      return $.ajax({
        method: "POST",
        url: "api/SurveyInstances/Properties/DetailsList",
        data: JSON.stringify(this.selectedChecks),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (!data || !data.length) {
            this.specificSettingsData.dataList = [];
            this.specificSettingsData.selectedCheck = {};
            return;
          }
          this.generalSettingsData.setData(data);
          // SurveyInstanceNote should be empty, if the notes are different and only shown if there are the same
          if (this.hasSameSurveyInstanceNote(data)) {
            this.generalSettingsData.SurveyInstanceNote =
              data[0].SurveyInstanceNote;
          } else {
            this.generalSettingsData.SurveyInstanceNote = "";
          }
          this.specificSettingsData.dataList = data;
          this.specificSettingsData.selectedCheck = data[0];
        },
        error: () => {
          console.error("Error on POST in getCheckSpecificData()");
          this.globals.showErrorSnackbar(this.lang.CM1045);
        },
      });
    },
    saveCheckSpecificData() {
      for (let check of this.specificSettingsData.dataList) {
        for (let property in check) {
          if (!check[property]) delete check[property];
        }
      }

      $.ajax({
        method: "PUT",
        url: "api/SurveyInstances/Properties/DetailsList",
        data: JSON.stringify(this.specificSettingsData.dataList),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        error: () => {
          console.error("Error on PUT in saveCheckSpecificData()");
          this.globals.showErrorSnackbar(this.lang.CM1049);
        },
      });
    },
    getWavesOfProject() {
      if (!this.selectedProject) {
        this.wavesOfProject = [];
        return;
      }

      let wl = this.dataLists.waveList.find((w) => {
        return w.ProjectGuid === this.selectedProject;
      });
      if (wl && wl.Waves) this.wavesOfProject = wl.Waves;
      else this.wavesOfProject = [];
    },
    getScenariosOfWave() {
      if (!this.generalSettingsData.SurveyInstanceWaveGuid) {
        this.scenariosOfWave = [];
        return;
      }

      let sl = this.dataLists.scenarioList.find((s) => {
        return s.WaveGuid === this.generalSettingsData.SurveyInstanceWaveGuid;
      });
      if (sl && sl.Scenarios) this.scenariosOfWave = sl.Scenarios;
      else this.scenariosOfWave = [];
    },
    selectedLocationChanged() {
      if (
        !this.previousLocationGuid ||
        this.generalSettingsData.SurveyInstanceLocationGuid ===
          this.previousLocationGuid
      )
        return;

      this.globals.$off(
        "CheckManagementEditModalSelectedLocationChangedCloseDialog"
      );
      this.globals.$once(
        "CheckManagementEditModalSelectedLocationChangedCloseDialog",
        () => {
          if (this.previousLocationGuid)
            this.generalSettingsData.SurveyInstanceLocationGuid =
              this.previousLocationGuid;
        }
      );
      this.globals.$off(
        "CheckManagementEditModalSelectedLocationChangedYesConfirmation"
      );
      this.globals.$once(
        "CheckManagementEditModalSelectedLocationChangedYesConfirmation",
        () => {
          this.previousLocationGuid = "";
        }
      );

      this.globals.$emit("openGlobalConfirmationDialog", {
        initiator: "CheckManagementEditModalSelectedLocationChanged",
        confirmationTitle: this.lang.CM1030,
        colorRed: true,
        yesButtonText: this.lang.CM1031,
        noButtonText: this.lang.CM1032,
        htmlText: `<p><b>${this.lang.CM1033}</b></p>`,
      });
    },
    async getLocationsOfSelectedClient() {
      if (!this.selectedClient) {
        this.locationsOfSelectedClient = [];
        return;
      }

      return $.ajax({
        method: "POST",
        url: `api/SurveyInstances/Locations/${this.selectedClient}`,
        success: (data) => {
          if (data[0]) {
            if (data[0].Locations)
              this.locationsOfSelectedClient = data[0].Locations;
            else this.locationsOfSelectedClient = [];
          }
        },
        error: () => {
          console.error("Error on POST in getLocationsOfSelectedClient()");
          this.globals.showErrorSnackbar("Location data access failed");
        },
      });
    },
    getProjectAttachments() {
      if (!this.selectedProject) {
        this.briefingAttachments = [];
        this.surveyAttachments = [];
        return;
      }
      let queryString = `/api/data/ProjectAttachments/${this.selectedProject}`;
      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          if (data.length > 0) {
            this.briefingAttachments = data.filter(
              (d) => d.AttachmentType === "Briefing"
            );
            this.surveyAttachments = data.filter(
              (d) => d.AttachmentType === "Survey"
            );
          }
        },
        error: () => {
          console.error(
            "Project attachments data access failed in getProjectAttachments()"
          );
          this.globals.showErrorSnackbar(this.lang.CM1050);
        },
      });
    },
    openHtmlEditor() {
      this.globals.$emit("openHtmlEditorModal");
      this.globals.$emit("sendDataToHtmlEditorModal", {
        title: this.lang.CM1051,
        content: this.generalSettingsData.SurveyInstanceDescription,
      });
    },
    getSurveyInstanceOrderIds() {
      return $.ajax({
        method: "POST",
        url: "api/SurveyInstances/SurveyInstanceOrderIds",
        data: this.selectedChecks.toString(),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) {
            this.globals.showErrorSnackbar(data.Error);
          } else {
            this.controllingSettingsData.dataList = data;
            this.controllingSettingsData.selectedCheck = data[0];
          }
        },
        error: (err) => {
          console.error(
            "Order data access failed in getSurveyInstanceOrderIds()", err
          );
          this.globals.showErrorSnackbar(this.lang.CM1078);
        },
      });
    },
    getOrders() {
      let queryString = `/api/SurveyInstances/Orders`;
      return $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          if (data.length > 0) {
            this.orders = data;
          }
        },
        error: (err) => {
          console.error("Get orders failed", err);
        },
      });
    },
    getSubProjects() {
      let queryString = `/api/SurveyInstances/SubProjects`;
      return $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          if (data.length > 0) {
            this.subProjects = data;
          }
        },
        error: (err) => {
          console.error("Get SubProjects failed", err);
        },
      });
    },
    saveCheckControllingData() {
      var controllingData = [];
      if(this.concontrollingSettingsData && this.concontrollingSettingsData.dataList && this.controllingSettingsData.dataList.length > 0){
        this.controllingSettingsData.dataList.forEach((check) => {
          controllingData.push({
            OrderId: check.OrderId || null,
            SurveyInstanceGuid: check.SurveyInstanceGuid,
          });
        });
        $.ajax({
          method: "POST",
          url: "api/SurveyInstances/UpdateSurveyInstanceOrderIds",
          data: JSON.stringify(controllingData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          error: () => {
            console.error("Error on POST in saveCheckControllingData()");
            this.globals.showErrorSnackbar("Saving controlling data failed.");
          },
        });
      }
    },
  },
  watch: {
    showDialog(value) {
      if (value) this.openEditChecksDialog();
      else this.closeEditChecksDialog();
    },
    selectedClient(newValue) {
      if (newValue) this.$clientChanged = true;
    },
    "generalSettingsData.SurveyInstanceWaveGuid"() {
      this.getScenariosOfWave();
    },
    "globals.selectedLanguage"() {
      this.languageStringsReceived = false;
      this.globals.getLanguageStrings(this, () => {
        this.languageStringsReceived = true;
      });
    },
    "controllingSettingsData.selectedCheck": {
      handler(newValue, oldValue) {
        if (newValue.OrderId) {
          newValue.SubProjectId = this.orders.find(
            (o) => o.OrderId == newValue.OrderId
          ).SubProjectId;
        }
      },
      deep: true,
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#editChecksDialog .modal-dialog {
  transition: all 200ms ease;
}

#collapseEditChecksGeneral > .panel-body {
  text-align: left;
  padding-top: 20px !important;
}

.shopper-info {
  text-align: left;
  padding: 10px 10px 10px 20px;
  border: 2px solid lightgray;
  border-radius: 10px;
  margin: 10px 0 10px 20px;
}
#approvedShopperDetailsContainer {
  font-size: 12px;
  padding-left: 40px;
}

#checkListContainer td,
#checkListContainer th {
  width: 100%;
}

.btn-cb-edit-checks {
  width: 300px;
  text-align: left;
  padding: 10px;
  display: block;
  margin: 0 0 0 20px;
}
.btn-state {
  padding-left: 0px;
  margin: 0;
  text-align: left;
  display: block;
  background-color: white !important;
}
.btn-edit {
  padding: 0px 4px;
  border-radius: 50%;
}
.btn-edit > i {
  padding-top: 2px;
}

.fg-general-settings-input {
  margin: 0 0 0 20px;
}

.form-group > label,
.form-group > div {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// CheckManagementEditModal.vue?c7a7a8c2